type pathParams = {
  [key: string]: string | number;
};

export const buildPath = (path: string, params: pathParams) => {
  return Object.keys(params).reduce((url, key) => {
    return url.replace(`:${key}`, `${params[key]}`);
  }, path);
};
